module.exports = __webpack_public_path__ + "img/kefu3.9f698c62.png";